module.exports = __webpack_public_path__ + "assets/img/2d38188195ca7b5e7855550435959f4c.png";